<div class="group-detail-sidebar">
    <div class="common-info-section">
        <div class="common-info-item common-header">
            <div class="label">Nhóm đề xuất</div>
            <div class="name">{{model.name}}</div>
        </div>
        <div class="common-info-item ">
            <div class="label">Tạo bởi</div>
            <div class="name">{{creator.fullName}}</div>
        </div>
        <div class="common-info-item ">
            <div class="label">Phân loại</div>
            <div class="name">{{model.category}}</div>
        </div>
        <div class="common-info-item ">
            <div class="label">SLAs (giờ)</div>
            <div class="name">{{model.sla / 3600000}} giờ</div>
        </div>
    </div>
    <div class="d-flex summary section">
        <div class="total flex-fill">
            <div class="label">Đề xuất</div>
            <div class="value">{{reportData.total}}</div>
        </div>
        <div class="solved flex-fill">
            <div class="label">Đã xử lý</div>
            <div class="value">{{reportData.processed}}</div>
        </div>
        <div class="accepted flex-fill">
            <div class="label">Chấp thuận</div>
            <div class="value">{{reportData.approved}}</div>
        </div>
    </div>
    <div class="group-setting section" [ngClass]="{'hidden': model.isDirect}">
        <div class="workflow" [matMenuTriggerFor]="workflow">
            <div class="item-header">
                <div class="label">Approving workflow</div>
                <mat-icon class="side">keyboard_arrow_down</mat-icon>
            </div>
            <div class="content">{{approvalType.friendlyName}}</div>
            <mat-menu #workflow="matMenu">
                <button
                    *ngFor="let type of approvalTypes"
                    class="item"
                    [ngClass]="{'selected': approvalType.id == type.id}"
                    mat-menu-item
                    (click)="onApprovalTypeChange(type)">
                    <div class="item-content">
                        <mat-icon class="workflow-color-{{type.id}}">lens</mat-icon>
                        <span>{{type.friendlyName}}</span>
                        <mat-icon class="checked">done</mat-icon>
                    </div>
                </button>
            </mat-menu>
        </div>

        <mat-divider class="divider"></mat-divider>

        <div class="supreme-role" (click)="openUserSelect()">
            <div class="item-header">
                <div class="label">Supreme role (Quyền tối cao)</div>
                <mat-icon class="side">keyboard_arrow_down</mat-icon>
            </div>
            <div class="content">{{approvalOwner.fullName}}</div>
        </div>

        <mat-divider class="divider"></mat-divider>

        <div class="direct-manager" [matMenuTriggerFor]="directManager">
            <div class="item-header">
                <div class="label">Direct manager</div>
                <mat-icon class="side">keyboard_arrow_down</mat-icon>
            </div>
            <div class="content">{{isDirectManager == true ? 'Yêu cầu duyệt' : 'Không yêu cầu'}}</div>
            <mat-menu #directManager="matMenu">
                <button class="item"
                        [ngClass]="{'selected': isDirectManager == true}"
                        mat-menu-item
                        (click)="onDirectManagerChange(true)">
                    <div class="item-content">
                        <mat-icon class="color-yes">lens</mat-icon>
                        <span>Có</span>
                        <mat-icon class="checked">done</mat-icon>
                    </div>
                </button>
                <button class="item"
                        [ngClass]="{'selected': isDirectManager == false}"
                        mat-menu-item
                        (click)="onDirectManagerChange(false)">
                    <div class="item-content">
                        <mat-icon class="color-no">lens</mat-icon>
                        <span>Không</span>
                        <mat-icon class="checked">done</mat-icon>
                    </div>
                </button>
            </mat-menu>
        </div>

        <mat-divider class="divider"></mat-divider>

        <div class="email-notification" [matMenuTriggerFor]="emailNotification">
            <div class="item-header">
                <div class="label">Email notification</div>
                <mat-icon class="side">keyboard_arrow_down</mat-icon>
            </div>
            <div class="content">Bật</div>
            <mat-menu #emailNotification="matMenu">
                <button class="item"
                        mat-menu-item
                        (click)="onEmailNotificationChange(true)">
                    <div class="item-content">
                        <mat-icon class="color-yes">lens</mat-icon>
                        <span>Bật</span>
                        <mat-icon class="checked">done</mat-icon>
                    </div>
                </button>
                <button class="item"
                        mat-menu-item
                        (click)="onEmailNotificationChange(false)">
                    <div class="item-content">
                        <mat-icon class="color-no">lens</mat-icon>
                        <span>Tắt</span>
                        <mat-icon class="checked">done</mat-icon>
                    </div>
                </button>
            </mat-menu>
        </div>
    </div>

    <div class="group-applying section" [ngClass]="{'hidden': model.isDirect}">
        <div class="apply-for" (click)="openDepartmentSelection()">
            <div class="item-header">
                <div class="label">Áp dụng cho</div>
                <mat-icon class="side">keyboard_arrow_down</mat-icon>
            </div>
            <div class="content">{{target.name}}</div>
        </div>
    </div>

    <div class="setting section" style="display: none;">
        <div class="advance-setting">
            <div class="item-header">
                <div class="label">Tùy chỉnh nâng cao</div>
                <mat-icon class="side">keyboard_arrow_down</mat-icon>
            </div>
            <div class="content">Tùy chỉnh nâng cao</div>
        </div>

        <mat-divider class="divider"></mat-divider>

        <div class="display-setting">
            <div class="item-header">
                <div class="label">Tùy chỉnh hiển thị</div>
                <mat-icon class="side">keyboard_arrow_down</mat-icon>
            </div>
            <div class="content">Tùy chỉnh hiển thị</div>
        </div>
    </div>
</div>
